/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {LinkContainer} from 'react-router-bootstrap';
import {Link} from 'react-router-dom';

import {Button, FormGroup, ControlLabel, HelpBlock, Modal} from 'eui-components';
import InstitutionSelector from './InstitutionSelector';
import SearchableInstitutionSelector from './SearchableInstitutionSelector';

import {adminOnly} from '../auth';

const InstitutionPicker = (props) => {
  const institutions = props.institutions;
  const unsetContextInstituion = (e) => {
    e.preventDefault();
    props.onSelect(null);
  };

  const AdminSearchPicker = adminOnly(() => <FormGroup controlId="searchInstitutionFormControl" bsSize="sm">
    <ControlLabel>
      <FormattedMessage id="InstitutionPicker.searchInstitutionLabel"
        defaultMessage="Search WorldCat Registry"/>
    </ControlLabel>
    <SearchableInstitutionSelector onSelect={props.onSelect} />
    <HelpBlock>
      <FormattedMessage id="InstitutionPicker.searchHelp"
        defaultMessage="Enter Registry ID, Institution Symbol, or ZIP code"/>
    </HelpBlock>
  </FormGroup>);

  return (
    <Modal show={props.show} animation={false} onHide={props.onHide} backdrop="static" id="institution-picker-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="InstitutionPicker.modalTitle" defaultMessage="Select an Institution"/>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <FormGroup controlId="selectInstitutionFormControl" bsSize="sm">
            <ControlLabel>
              <FormattedMessage id="InstitutionPicker.formInstitutionLabel"
                defaultMessage="Institution"/>
            </ControlLabel>
            <InstitutionSelector institutions={institutions} onSelect={props.onSelect}/>
          </FormGroup>
          <AdminSearchPicker />
          <FormGroup>
            <LinkContainer to="" id="institution-picker-unaffiliated-link">
              <Link to="/apps" onClick={unsetContextInstituion}><FormattedMessage id="InstitutionPicker.unaffiliatedLinkLabel"
                defaultMessage="I am not affiliated with an institution"/></Link>
            </LinkContainer>
          </FormGroup>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} id="institution-picker-cancel-btn">
          <FormattedMessage id="InstitutionPicker.cancelButtonLabel"
            defaultMessage="Cancel"/>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

/**
 * Validation of property types.
 */
InstitutionPicker.propTypes = {
  institutions: PropTypes.arrayOf(PropTypes.object),
  show: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onHide: PropTypes.func
};

/**
 * Default property values.
 * @type {{institutions: Array}}
 */
InstitutionPicker.defaultProps = {
  institutions: [],
  show: false,
  onHide: () => {}
};

export default InstitutionPicker;



// WEBPACK FOOTER //
// ./src/InstitutionPicker/InstitutionPicker.js